import getPercentDiff from './getPercentDiff';
import getCountryName from './getCountryName';

export default {
  install(Vue) {
    Vue.filter('getPercentDiff', getPercentDiff);
    Vue.filter('getCountryName', getCountryName);
  },
};
